import React from 'react';
import Link from 'next/link';
import { BFIslandButton, BFIslandColors } from '@buzzfeed/react-components';
import seagullSpeechBubble from '../../../public/static/images/seagullSpeechBubble.png';
import { FAQ_ITEMS, ITUNES_APP_URL } from '../../../constants';
import ProgressDots from '../../ProgressDots';
import { useMediaQuery } from '../../../hooks';

import styles from './index.module.scss';

const FAQ = () => {
  const { isLargeScreen } = useMediaQuery();

  const handleDownloadClick = () => {
    window.open(`${ITUNES_APP_URL}?pt=329394&ct=homepage&mt=8`, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className={styles.section}>
      <header className={styles.header}>
        <h2 className={styles.title}>
          <img className={styles.icon} src={seagullSpeechBubble} alt="" />
          <div className={styles.titleText}>
            <span>BF Island: </span>
            <span>The Unserious FAQ</span>
          </div>
        </h2>
      </header>

      <div className={styles.faqList}>
        {FAQ_ITEMS.map((item) => (
          <article className={styles.item} key={item.title}>
            <h3 className={styles.question}>{item.title}</h3>
            <p className={styles.answer}>{item.description}</p>
          </article>
        ))}
      </div>
      {!isLargeScreen && <ProgressDots count={3} activeIndex={0} />}

      <div className={styles.footerCta}>
        <BFIslandButton
          onClick={handleDownloadClick}
          text="Download BF Island"
          size="small"
          bgColor={BFIslandColors.LIME}
          width="203px"
        />
        <p className={styles.footerLegalText}>
          <Link href="/privacypolicy">
            <a className={styles.footerLegalLink}>Privacy policy</a>
          </Link>
          {' | '}
          <Link href="/user-agreement">
            <a className={styles.footerLegalLink}>User agreement</a>
          </Link>
        </p>
      </div>
    </section>
  );
};

export default FAQ;
